<template>
    <a class="mySlot" :href="url">
        <slot name="button"><a-button>submit</a-button></slot>
        <slot name="title">
            this is title
        </slot>

        <slot name="foot">
            this is foot
        </slot>
    </a>
</template>
<script>
    export default {
        data() {
            return {
                url:'http://www.baidu.com'
            };
        },
        methods: {

        },
    };
</script>
<style scoped>
    .editable-row-operations a {
        margin-right: 8px;
    }
    .mySlot{
        color: white;
    }
</style>
